import { engageGallery } from './gallerySlider'
import { globals } from '@/src/globals'
import axios from 'axios/dist/axios'
import { renderNewGallery } from '../renderer/singleGallery'

export const axios_requestNewGalleries = (): void => {
  /**
   * List of all existing lists
   */
  const allGalleryLists = document.querySelectorAll('.js-galleryList') as unknown as HTMLElement[]

  /**
   * Processes the individual list
   * @param list The current HTML wrapper for the individual list
   */
  const engagePostList = (list: HTMLElement) => {
    const triggerElement = list.querySelector('.js-endlessLoad') as HTMLElement

    if (triggerElement) {
      // Amount of posts to set as determined in the WP admin
      const galleryAmount = list.dataset.jsGalleryAmount as string

      triggerElement.addEventListener('click', () => {
        // Get current list of child nodes to determine current offset
        const galleryCount = list.querySelectorAll('.js-singleGallery').length
        axiosRequest(galleryAmount, galleryCount, list, triggerElement)
      }, false)
    }
  }

  /**
   * Requests the next batch of galleries from the WP REST API
   * @param galleryAmount Amount of galleries to load with each request
   * @param postOffset Current offset of the request (automatic)
   */
  const axiosRequest = (galleryAmount: string, postOffset: number, list: HTMLElement, triggerElement: HTMLElement) => {
    const requestURL = `${globals.externalInput.wpAjaxURL}/wp-json/wp/v2/galleries?per_page=${galleryAmount}&offset=${postOffset}`
    axios.get(requestURL)
      .then(response => {
        console.log(response)

        const newGalleryList = response.data
        newGalleryList.forEach(gallery => {
          const tempDiv = document.createElement('div')
          const sublist = list.querySelector('.js-galleryListInner') as unknown as HTMLElement
          sublist.appendChild(tempDiv)
          tempDiv.outerHTML = renderNewGallery(gallery)

          // Hook up new gallery controls
          engageGallery(sublist.lastElementChild as HTMLElement)
        })
        if (response.data.length !== galleryAmount) {
          triggerElement.remove()
        }
      })
      .catch(e => {
        console.log(e)
      })
  }

  /**
   * Handle all existing lists
   */
  allGalleryLists.forEach((list: HTMLElement) => {
    engagePostList(list)
  })
}
